import cookie from 'react-cookies';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { plainToClass } from 'class-transformer';

import { airPayoutJourneysApi } from 'api';
import { TURNSTILE_COOKIE } from 'config/cookies';
import { type IJourney, Journey } from 'models/Journey';
import { resetTurnstileToken } from 'utils/turnstile';

const triggerAirPayoutForJourney = async (
  journeyId: number,
  payload: airPayoutJourneysApi.AirPayoutRequest,
) => {
  const token = cookie.load(TURNSTILE_COOKIE);
  const [error, response] =
    await airPayoutJourneysApi.triggerAirPayoutForJourneys(
      journeyId,
      payload,
      token,
    );

  if (error) {
    throw error;
  }

  resetTurnstileToken();

  return response;
};

const useTriggerAirPayoutJourney = () => {
  const queryClient = useQueryClient();
  const requestAirPayoutMutation = useMutation({
    mutationFn: (params: {
      journeyId: number;
      params: airPayoutJourneysApi.AirPayoutRequest;
    }) => triggerAirPayoutForJourney(params.journeyId, params.params),

    onSuccess: (data: IJourney) => {
      const updatedJourney = plainToClass(Journey, data);
      queryClient.invalidateQueries({ queryKey: ['journeys'] });
      queryClient.invalidateQueries({
        queryKey: ['journey', data.id, 'airPayouts'],
      });
      queryClient.setQueryData(['journey', data.id], updatedJourney);
    },
  });
  return requestAirPayoutMutation;
};

export default useTriggerAirPayoutJourney;
